import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNoIndex } from "../hooks/useNoIndex";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { Button } from "../components/ui/button";
import { AdminPrices } from "../components/admin/AdminPrices";
import { AdminPackages } from "../components/admin/AdminPackages";
import { AdminQuotes } from "../components/admin/AdminQuotes";
import { AdminContent } from "../components/admin/AdminContent";
import { AdminGallery } from "../components/admin/AdminGallery";
import { AdminVideos } from "../components/admin/AdminVideos";
import { AdminTravelCosts } from "../components/admin/AdminTravelCosts";
import { AdminSeoPages } from "../components/admin/AdminSeoPages";
import { AdminAlbums } from "../components/admin/AdminAlbums";
import { AdminEvents } from "../components/admin/AdminEvents";
import { UpcomingEventsBanner } from "../components/admin/UpcomingEventsBanner";
import { AdminChangePassword } from "../components/admin/AdminChangePassword";
import { LogOut } from "lucide-react";

export default function AdminDashboard() {
  useNoIndex();
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const [eventsVersion, setEventsVersion] = useState(0);

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-secondary/30" data-testid="admin-dashboard-page">
      <header className="bg-white border-b px-6 py-4 flex items-center justify-between">
        <div>
          <h1 className="font-semibold text-lg">Panel Privado — The Wedding Photographie</h1>
          <p className="text-xs text-muted-foreground">Sesión: {user?.username}</p>
        </div>
        <div className="flex items-center gap-3">
          <AdminChangePassword />
          <Button data-testid="admin-logout-button" variant="outline" onClick={handleLogout}>
            <LogOut size={16} className="mr-2" /> Cerrar sesión
          </Button>
        </div>
      </header>

      <UpcomingEventsBanner refreshKey={eventsVersion} />

      <main className="max-w-5xl mx-auto p-6">
        <Tabs defaultValue="packages">
          <TabsList data-testid="admin-tabs-list" className="mb-6 flex-wrap h-auto">
            <TabsTrigger data-testid="admin-tab-packages" value="packages">Paquetes</TabsTrigger>
            <TabsTrigger data-testid="admin-tab-prices" value="prices">Precios</TabsTrigger>
            <TabsTrigger data-testid="admin-tab-travel-costs" value="travel-costs">Viáticos</TabsTrigger>
            <TabsTrigger data-testid="admin-tab-quotes" value="quotes">Cotizaciones</TabsTrigger>
            <TabsTrigger data-testid="admin-tab-events" value="events">Calendario de Eventos</TabsTrigger>
            <TabsTrigger data-testid="admin-tab-content" value="content">Inicio y Textos</TabsTrigger>
            <TabsTrigger data-testid="admin-tab-gallery" value="gallery">Galería</TabsTrigger>
            <TabsTrigger data-testid="admin-tab-videos" value="videos">Videos</TabsTrigger>
            <TabsTrigger data-testid="admin-tab-seo-pages" value="seo-pages">Páginas SEO</TabsTrigger>
            <TabsTrigger data-testid="admin-tab-albums" value="albums">Álbumes</TabsTrigger>
          </TabsList>

          <TabsContent value="packages"><AdminPackages /></TabsContent>
          <TabsContent value="prices"><AdminPrices /></TabsContent>
          <TabsContent value="travel-costs"><AdminTravelCosts /></TabsContent>
          <TabsContent value="quotes"><AdminQuotes /></TabsContent>
          <TabsContent value="events"><AdminEvents onEventsChanged={() => setEventsVersion((v) => v + 1)} /></TabsContent>
          <TabsContent value="content"><AdminContent /></TabsContent>
          <TabsContent value="gallery"><AdminGallery /></TabsContent>
          <TabsContent value="videos"><AdminVideos /></TabsContent>
          <TabsContent value="seo-pages"><AdminSeoPages /></TabsContent>
          <TabsContent value="albums"><AdminAlbums /></TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
